<script>
    import DetailMapViewer from '../partials/data_detail/DetailMapViewer.svelte';
    import DetailChart from '../partials/data_detail/DetailChart.svelte';
    import { datasetStore } from '../stores/dataset';
    import { useLocation } from 'svelte-routing';
    import { base } from '../utils/base';
    import { onMount, onDestroy } from 'svelte';
    import { chartStore } from '../stores/chart';
    import { chartConfigs } from '../stores/chart_data';
    const location = useLocation();
    
    // Get id from query params
    $: searchParams = new URLSearchParams($location.search);
    $: id = parseInt(searchParams.get('id'));
    
    // Get dataset details
    $: dataset = $datasetStore.find(d => d.id === id);
    
    // Get chart configurations based on dataset id and map to appropriate chart type
    $: chartOptionsList = (chartConfigs[id] || []).map(config => {
        switch (config.type) {
            case 'column':
                return chartStore.getColumnChartData(config);
            case 'pie':
                return chartStore.getPieChartData(config);
            case 'bar':
                return chartStore.getBarChartData(config);
            case 'line':
            return chartStore.getLineChartData(config);
            case 'stock':
                return chartStore.getStockColumnChartData(config);
            case 'stacked_column':
                return chartStore.getStackColumnChartData(config);
            default:
                return chartStore.getColumnChartData(config); // fallback to column chart
        }
    });

    onMount(() => {
        console.log("data detail page")
        window.scrollTo(0, 0);
    });

    onDestroy(() => {
        // Cleanup any subscriptions or side effects here
    });
</script>





<!-- Content Section -->
<div class="px-4 sm:px-6 lg:px-8 py-6 bg-white">
    <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
        {dataset?.dataset || 'Loading...'}
    </h1>
    
    <div class="prose max-w-none mt-6"> 
        <p class="text-gray-600 leading-relaxed text-justify">
            {dataset?.paragraph || 'No description available.'}
        </p>
        
        <!-- Pass the dataset to DetailMapViewer -->
        <div class="mt-8">
            {#if dataset && dataset.mapservice_rest_url && dataset.mapservice_rest_url.length > 0}
            <DetailMapViewer {dataset} />
            {/if}
        </div>

        <!-- Add Chart Section -->
        <div class="mt-8">
            {#if chartOptionsList.length === 2}
                <!-- Two charts: full width -->
                <div class="space-y-8">
                    {#each chartOptionsList as chartOptions}
                        <div class="w-full">
                            <DetailChart {chartOptions} />
                        </div>
                    {/each}
                </div>
            {:else if chartOptionsList.length === 3}
                <!-- Three charts: first full width, other two side by side -->
                <div class="space-y-8">
                    <!-- First chart full width -->
                    <div class="w-full">
                        <DetailChart chartOptions={chartOptionsList[0]} />
                    </div>
                    <!-- Two charts side by side -->
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <DetailChart chartOptions={chartOptionsList[1]} />
                        </div>
                        <div>
                            <DetailChart chartOptions={chartOptionsList[2]} />
                        </div>
                    </div>
                </div>
            {:else}
                <!-- Default layout for other numbers of charts -->
                <div class="space-y-8">
                    {#each chartOptionsList as chartOptions}
                        <div>
                            <DetailChart {chartOptions} />
                        </div>
                    {/each}
                </div>
            {/if}
        </div>

        <!-- Useful Links Section -->
        {#if dataset?.application_link || dataset?.rds_link}
            <div class="mt-8">
                <h2 class="text-xl font-semibold text-gray-800 mb-4">Useful Links</h2>
                <div class="space-y-3">
                    {#if dataset?.application_link}
                        <div>
                            <a 
                                href={dataset.application_link} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                class="text-blue-600 hover:text-blue-800 flex items-center"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                                {dataset.application_link}
                            </a>
                        </div>
                    {/if}
                    {#if dataset?.rds_link}
                        <div>
                            <a 
                                href={dataset.rds_link} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                class="text-blue-600 hover:text-blue-800 flex items-center"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                </svg>
                               {dataset.rds_link}
                            </a>
                        </div>
                    {/if}
                </div>
            </div>
        {/if}
    </div>
</div>
